import img1 from './4.jpg'
import himg from './h.jpg'
import mb from './m.jpg'
import art from './art2.jpg'
export const sliderItems = [
    {
      id: 1,
      img: img1,
      title: "FIND YOUR NEXT BOOK WITH BOOK ATTIC",
      desc: "“The place to get lost in a world of books”",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: mb,
      title: "BEST OF MYSTERY",
      desc: "“A wonderful fact to reflect upon, that every human creature is constituted to be that profound secret and mystery to every other.”",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: art,
      title: "ARTICLES",
      desc: "“The more that you read, the more things you will know. The more that you learn, you more places you will go...................  –Dr. Seuss.",
      bg: "fbf0f4",
    },
  ];